module.exports = __webpack_public_path__ + "img/FINCOR-.e4c19799.jpg";